export class CondoSkillset {
    public id: string;
    public condoSkillsetName: string;
}

export class UserCondoSkillset {
    public id: string;
    public condoSkillset: CondoSkillset;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/condoskillsets/condoSkillset.model.ts